/**
 * O unico lugar do site que fala com o Supabase.
 *
 * Componente nao importa Supabase nem monta URL de banco: chama estas
 * funcoes. Sem a biblioteca do Supabase de proposito: o site so faz tres
 * chamadas, e fetch resolve sem acrescentar peso ao pacote.
 *
 * A chave daqui e a publica (publishable). Ela vai para o navegador e
 * qualquer pessoa pode le-la; o que protege os dados sao as regras do banco,
 * testadas por ataque em 20/10/2026 (ver 05-site/03-banco-de-dados.md).
 */

const URL_BANCO = import.meta.env['VITE_SUPABASE_URL'];
const CHAVE_PUBLICA = import.meta.env['VITE_SUPABASE_ANON_KEY'];

/** O banco esta configurado neste build. Sem isso, nada e enviado. */
export const BANCO_CONFIGURADO = Boolean(URL_BANCO && CHAVE_PUBLICA);

/**
 * Coleta ligada: o formulario grava de verdade.
 *
 * Fica desligada ate existirem a politica de privacidade e o encarregado
 * indicado. Ligar e so gerar o build com VITE_COLETA=true.
 */
export const COLETA = import.meta.env['VITE_COLETA'] === 'true' && BANCO_CONFIGURADO;

if (import.meta.env['VITE_COLETA'] === 'true' && !BANCO_CONFIGURADO) {
  console.error('VITE_COLETA=true, mas falta VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY. Coleta desligada.');
}

export interface NovoContato {
  nome: string;
  email: string;
  ddd: string;
  telefone: string;
  finalidade: 'lista' | 'institucional';
  cargo: string | null;
  organizacao: string | null;
  consentimento_versao: string;
  origem: string;
}

export type ResultadoDoEnvio = 'gravado' | 'repetido' | 'erro';

export async function gravarContato(contato: NovoContato): Promise<ResultadoDoEnvio> {
  if (!BANCO_CONFIGURADO) return 'erro';
  try {
    const resposta = await fetch(`${URL_BANCO}/rest/v1/contatos`, {
      method: 'POST',
      headers: {
        apikey: CHAVE_PUBLICA,
        'Content-Type': 'application/json',
        // Sem pedir a linha de volta: o navegador nao tem permissao de ler.
        Prefer: 'return=minimal',
      },
      body: JSON.stringify({ ...contato, consentiu: true }),
    });
    if (resposta.status === 201) return 'gravado';
    // Indice unico de e-mail por finalidade: ja esta na lista.
    if (resposta.status === 409) return 'repetido';
    return 'erro';
  } catch {
    return 'erro';
  }
}

async function chamarFuncao(nome: string, corpo: Record<string, string>) {
  if (!BANCO_CONFIGURADO) return null;
  try {
    const resposta = await fetch(`${URL_BANCO}/functions/v1/${nome}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(corpo),
    });
    if (!resposta.ok) return null;
    return (await resposta.json()) as { situacao?: string };
  } catch {
    return null;
  }
}

/** Confirma a saida pelo codigo do link. 'saiu' e 'fora' sao, para a pessoa, o mesmo resultado. */
export async function confirmarSaida(token: string): Promise<'saiu' | 'erro'> {
  const retorno = await chamarFuncao('sair', { token });
  return retorno?.situacao === 'saiu' || retorno?.situacao === 'fora' ? 'saiu' : 'erro';
}

/** Pede o link de saida para um e-mail. A resposta nao diz se ele estava cadastrado. */
export async function pedirSaida(email: string): Promise<'pedido' | 'erro'> {
  const retorno = await chamarFuncao('pedir-saida', { email });
  return retorno?.situacao === 'pedido' ? 'pedido' : 'erro';
}
